import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import * as sweetalert from "sweetalert";
import { ScriptLoaderService } from "./../../_services/script-loader.service";
import { AlertService } from "./../../auth/_services/alert.service";
import { AlertComponent } from "./../../auth/_directives/alert.component";
import { UserService } from "./../../auth/_services/user.service";
import { CookieService } from "ngx-cookie-service";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: "m-grid.m-grid--hor.m-grid--root.m-page",
  templateUrl: "./../../components/custompassword/resetpassword.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit {
  selectedLang: string;
  model: any = {};
  loading = false;
  userId: any;
  code: any;
  hostUrl: any = environment.apiUrl;
  // hostUrl: any = window.location.hostname;

  @ViewChild("alertResetPassword", { read: ViewContainerRef })
  alertResetPassword: ViewContainerRef;

  //add vithujan 30-08-2022
  showLinkExpiry: boolean = false;
  TemplateId: string = '';
  //end

  //added by vithujan 01-11-2022
  TokenInfo: any = {};
  //end

  //added by vithujan 02-11-2022
  length0: string;
  length1: string;
  length2: string;
  length3: string;
  message = '';
  private colors = ['red', 'darkorange', 'green', 'darkgreen'];
  checklen = 0;
  isShowStatus: boolean = false;
  //end

  constructor(
    private _alertService: AlertService,
    private cfr: ComponentFactoryResolver,
    private _userService: UserService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private cookieService: CookieService,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private _script: ScriptLoaderService,
    private http: HttpClient,
    private toaster: ToastrService,
    private decryptpipe: DecryptPipe
  ) {
    if (this.hostUrl == 'https://nol.ifreightbox.net/') {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
    else {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
  }

  url_token: any = '';
  reset_type: any = '';
  ngOnInit() {
    this._script
      .loadScripts(
        "body",
        [
          "assets/vendors/base/vendors.bundle.js",
          "assets/demo/default/base/scripts.bundle.js"
        ],
        true
      )
      .then(() => {
        this._activatedRoute.params.subscribe((params: Params) => {
          // this.userId = this._activatedRoute.snapshot.queryParams["Id"];
          var token = this.cookieService.get("user_access_token");
          let user_access_token = '';
          if (token == null || token == '' || token == undefined) {
            user_access_token = '';
          } else {
            user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieService.get("user_access_token")));
          }
          // let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieService.get("user_access_token")));
          this.code = user_access_token; //"1";//this._activatedRoute.snapshot.queryParams['code'];
          // this.model.Id = this.userId;
          this.model.Code = this.code;

          //add vithujan 31-08-2022
          this.TemplateId = this._activatedRoute.snapshot.queryParams["templateid"];
          this.url_token = this._activatedRoute.snapshot.queryParams['code'];
          this.reset_type = this._activatedRoute.snapshot.queryParams['type'];
          this.ResetPasswordLinkExpiry(this.TemplateId, this.url_token);
          //end
        });
      });
    // this.validateToken(); 
  }

  validatePassword() {
    if (this.model.Password.length < 6) {
      const characterslong = this.translate.instant("ALERTMESSAGES.characterslong");
      this.showAlert("alertResetPassword");
      this._alertService.error(
        characterslong,
        false
      );
      return false;
    }
    if (this.model.ConfirmPassword.length < 6) {
      const characterslong = this.translate.instant("ALERTMESSAGES.characterslong");
      this.showAlert("alertResetPassword");
      this._alertService.error(
        characterslong,
        false
      );
      return false;
    }
    if (this.model.Password != this.model.ConfirmPassword) {
      const donotmatch = this.translate.instant("ALERTMESSAGES.donotmatch");
      this.showAlert("alertResetPassword");
      this._alertService.error(
        donotmatch,
        false
      );
      return false;
    }
    if (this.message != 'Strong') {
      const strongPass = this.translate.instant("ALERTMESSAGES.EnterStrongPassword");
      this.showAlert("alertResetPassword");
      this._alertService.error(
        strongPass,
        false
      );
      return false;
    }
    // if (this.userId != null && this.userId.length > 0) {

    // }
    return true;
  }

  validateToken() {
    const createdsuccessfully = this.translate.instant("ALERTMESSAGES.createdsuccessfully");
    this._userService.validateToken(this.model).subscribe(
      (data) => {
        this.showAlert("alertResetPassword");
        this._alertService.success(
          createdsuccessfully,
          true
        );
        this.loading = false;
        this.model = {};

        setTimeout(() => {
          this._router.navigate(["/home"]);
        }, 1000);
      },
      (error) => {
        this.loading = false;
        this.showAlert("alertResetPassword");
        this._alertService.error(error._body.replace(/"/g, ""), false);
      }
    );
  }

  setpassword() {
    if (!this.validatePassword()) {
      return false;
    }
    this.loading = true;
    // this.model.Id = this.userId;
    this.model.Token = this.url_token;
    this.model.TemplateId = this.TemplateId;

    const Yourpasswordiscreatedsuccessfully = this.translate.instant("ALERTMESSAGES.Yourpasswordiscreatedsuccessfully");
    this._userService.setPassword(this.model).subscribe(
      (data) => {
        this.showAlert("alertResetPassword");
        this._alertService.success(
          Yourpasswordiscreatedsuccessfully,
          true
        );

        //add vithujan 31-08-2022
        this.ChangeResetLinkStatus();
        //end

        this.loading = false;
        this.model = {};
        setTimeout(() => {
          if (environment.apiUrl == 'https://nol.ifreightbox.net/') {
            //added by vithujan 01-11-2022
            this.DeleteSysToken();
            //end
            this._router.navigate(["./home"]);
          }
          else {
            // Commented and added by vithujan 01-11-2022
            // this._router.navigate(["./index"]);
            this.DeleteSysToken();
            this._router.navigateByUrl("/login");
            //end
          }
        }, 2000);
        // setTimeout(() => {
        //   this._router.navigate(["/login"]);
        // }, 1000);
      },
      (error) => {
        this.loading = false;
        var errorMsg = JSON.parse(error._body);
        if (errorMsg.Message == "Old password and new password cannot be same") {
          this.toaster.error(this.translate.instant("ALERTMESSAGES.PasswordNotMatch"), "Error");
        } else {
          this.showAlert("alertResetPassword");
        }
        this._alertService.error(error._body.replace(/"/g, ""), false);
      }
    );
  }

  processPassword() {
    if (this.reset_type == 'newpass') {
      this.setpassword();
    } else {
      this.resetPassword();
    }
  }

  resetPassword() {
    if (!this.validatePassword()) {
      return false;
    }

    if (this.TemplateId != '' || this.TemplateId != undefined || this.TemplateId != null) {
      this.ResetPasswordLinkExpiry(this.TemplateId, this.url_token);
    }

    setTimeout(() => {
      if (this.showLinkExpiry == false) {
        this.loading = true;

        this.model.TemplateId = this.TemplateId;
        this.model.Token = this.url_token;

        this._userService.resetPassword(this.model).subscribe(
          (data) => {
            const completedsuccessfully = this.translate.instant("ALERTMESSAGES.completedsuccessfully");
            this.loading = false;
            this.model = {};
            this.showAlert("alertResetPassword");
            this._alertService.success(
              completedsuccessfully,
              true
            );

            //add vithujan 31-08-2022
            this.ChangeResetLinkStatus();
            //end

            setTimeout(() => {
              if (environment.apiUrl == 'https://nol.ifreightbox.net/') {
                //added by vithujan 01-11-2022
                this.DeleteSysToken();
                //end
                this._router.navigate(["./home"]);
              }
              else {
                // Commented and added by vithujan 01-11-2022
                // this._router.navigate(["./index"]);
                this.DeleteSysToken();
                this._router.navigateByUrl("/login");
                //end
              }
            }, 2000);
          },
          (error) => {
            this.loading = false;
            this.showAlert("alertResetPassword");
            this._alertService.error(error._body.replace(/"/g, ""), false);
          }
        );
      }
    }, 2000);
  }

  //added by vithujan 01-11-2022
  DeleteSysToken() {
    // this.TokenInfo.UserId = this.userId;
    this.TokenInfo.Token = this.url_token;
    this.TokenInfo.TemplateId = this.TemplateId;

    var apiUrl = environment.apiUrl + "api/User/DeleteSysTokenV2";

    this.http.post(apiUrl, this.TokenInfo).subscribe(
      (data) => {
        this.TokenInfo = {};

        localStorage.removeItem("rights_assigned");
        localStorage.removeItem("user_Type_Rights");
        this.cookieService.delete("User");
      },
      (error) => {
        this._alertService.error(error._body.replace(/"/g, ""), false);
      }
    );
  }
  //end

  showAlert(target) {
    // this[target].clear();
    let factory = this.cfr.resolveComponentFactory(AlertComponent);
    let ref = this[target].createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }

  //add vithujan 30-08-2022
  showLinkInvalid: boolean = false;
  ResetPasswordLinkExpiry(templateid: any, token: any) {
    var obj: any = {};
    obj.TemplateId = templateid;
    obj.Token = token;

    var apiUrl = environment.apiUrl + "api/User/GetResetPasswordLinkExpiry";

    this.http.post(apiUrl, obj).subscribe((response: any) => {

      if (this.reset_type != 'newpass') {
        if (response.length > 0) {
          var data = response[0];

          // this.userId = data.UserId;
          // this.model.Id = data.UserId;

          if (data.MinuteDiff >= 5) {
            this.showLinkExpiry = true;
          } else if (data.IsUsed == true) {
            this.showLinkExpiry = true;
          } else {
            this.showLinkExpiry = false;
          }
        } else {
          this.showLinkExpiry = true;
        }
      }

    }, (err) => {
      console.log(err);
      this.showLinkInvalid = true;
      this.toaster.error(err._body.replace(/"/g, ""), "error");
    });
  }

  ChangeResetLinkStatus() {
    var apiUrl = environment.apiUrl + "api/User/UpdatePasswordResetLinkState?Id=" + this.TemplateId;

    this.http.get(apiUrl).subscribe(response => {
      console.log(response);

    }, (err) => {
      console.log(err);
      this.toaster.error(err._body.replace(/"/g, ""), "error");
    });
  }
  //end

  //added by vithujan 02-11-2022
  // onChangePassword(event: any) {
  //   if (event.length > 0) {
  //     this.isShowStatus = true;
  //   } else {
  //     this.isShowStatus = false;
  //   }

  //   const regex = /[$-/:-?{-~!"^_@`\[\]]/g;
  //   const lowerLetters = /[a-z]+/.test(event);
  //   const upperLetters = /[A-Z]+/.test(event);
  //   const numbers = /[0-9]+/.test(event);
  //   const symbols = regex.test(event);

  //   const flags = [lowerLetters, upperLetters, numbers, symbols];

  //   let Passwordmaches = 0;
  //   for (const flag of flags) {
  //     Passwordmaches += flag === true ? 1 : 0;
  //   }

  //   this.checklen += 2 * event.length + ((event.length >= 10) ? 1 : 0);
  //   this.checklen += Passwordmaches * 10;

  //   //Check length  
  //   this.checklen = (event.length <= 8) ? Math.min(this.checklen, 3) : this.checklen;

  //   this.checklen = (Passwordmaches === 1) ? Math.min(this.checklen, 10) : this.checklen;
  //   this.checklen = (Passwordmaches === 2) ? Math.min(this.checklen, 20) : this.checklen;
  //   this.checklen = (Passwordmaches === 3) ? Math.min(this.checklen, 30) : this.checklen;
  //   this.checklen = (Passwordmaches === 4) ? Math.min(this.checklen, 40) : this.checklen;

  //   this.setBarColors(4, '#DDD');
  //   if (event) {
  //     const c = this.getColor(this.checklen);
  //     this.setBarColors(c.idx, c.col);

  //     switch (c.idx) {
  //       case 1:
  //         this.message = 'Weak';
  //         break;
  //       case 2:
  //         this.message = 'Average';
  //         break;
  //       case 3:
  //         this.message = 'Strong';
  //         break;
  //       case 4:
  //         this.message = 'Strong';
  //         break;
  //     }
  //   } else {
  //     this.message = '';
  //   }

  // }

  onChangePassword(event: any) {
    if (event.length > 0) {
      this.isShowStatus = true;
    } else {
      this.isShowStatus = false;
    }

    const regex = /[$-/:-?{-~!"^_@`[]]/g;
    const lowerLetters = /[a-z]+/.test(event);
    const upperLetters = /[A-Z]+/.test(event);
    const numbers = /[0-9]+/.test(event);
    const symbols = regex.test(event);

    // Prevent continuous number sequences like 123, 234, ..., 789
    const continuousNumbers = /(012|123|234|345|456|567|678|789|890)/.test(event);

    if (continuousNumbers) {
      this.message = 'Weak: Avoid continuous number sequences';
      return;
    }

    const flags = [lowerLetters, upperLetters, numbers, symbols];

    let Passwordmaches = 0;
    for (const flag of flags) {
      Passwordmaches += flag === true ? 1 : 0;
    }

    this.checklen += 2 * event.length + ((event.length >= 10) ? 1 : 0);
    this.checklen += Passwordmaches * 10;

    //Check length
    this.checklen = (event.length <= 8) ? Math.min(this.checklen, 3) : this.checklen;

    this.checklen = (Passwordmaches === 1) ? Math.min(this.checklen, 10) : this.checklen;
    this.checklen = (Passwordmaches === 2) ? Math.min(this.checklen, 20) : this.checklen;
    this.checklen = (Passwordmaches === 3) ? Math.min(this.checklen, 30) : this.checklen;
    this.checklen = (Passwordmaches === 4) ? Math.min(this.checklen, 40) : this.checklen;

    this.setBarColors(4, '#DDD');
    if (event) {
      const c = this.getColor(this.checklen);
      this.setBarColors(c.idx, c.col);

      switch (c.idx) {
        case 1:
          this.message = 'Weak';
          break;
        case 2:
          this.message = 'Average';
          break;
        case 3:
          this.message = 'Strong';
          break;
        case 4:
          this.message = 'Strong';
          break;
      }
    } else {
      this.message = '';
    }
  }

  private getColor(s) {
    let idx = 0;
    if (s <= 10) {
      idx = 0;
    } else if (s <= 20) {
      idx = 1;
    } else if (s <= 30) {
      idx = 2;
    } else if (s <= 40) {
      idx = 3;
    } else {
      idx = 4;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  private setBarColors(count, col) {
    for (let n = 0; n < count; n++) {
      this['length' + n] = col;
    }
  }
  //end
}
